module.exports = __webpack_public_path__ + "img/upload-xls.19da6971.svg";